const development = {
  apiUrl: 'https://localhost:44312/v1',
}

const production = {
  apiUrl: 'https://api.reapit.simplyconveyancing.co.uk/v1',
}

const simplyConfig = process.env.REACT_APP_ENV === 'production' ? production : development

export default simplyConfig
